import { jsx } from "react/jsx-runtime";
import { createElement } from "react";
import { Carousel } from "@zillow/zrs-cms";
import PropTypes from "prop-types";
import { generateBlockList } from "../../components/BlockList/BlockList.esm.js";
const BlockCarousel = ({
  attrs,
  index,
  innerBlocks
}) => {
  const contents = innerBlocks.map((innerBlock) => /* @__PURE__ */ jsx(Carousel.Item, { id: innerBlock.attrs.id, justifyContent: innerBlock.attrs.justifyContent, alignItems: innerBlock.attrs.alignItems, tab: innerBlock.attrs.heading, children: generateBlockList({
    blocks: innerBlock.innerBlocks
  }) }, innerBlock.attrs.id));
  return /* @__PURE__ */ createElement(Carousel, { ...attrs, key: index }, contents);
};
BlockCarousel.propTypes = {
  index: PropTypes.number,
  innerBlocks: PropTypes.arrayOf(PropTypes.shape({})),
  attrs: PropTypes.shape({
    id: PropTypes.string,
    showDots: PropTypes.bool,
    showTabs: PropTypes.bool,
    showArrows: PropTypes.bool
  })
};
export {
  BlockCarousel as default
};
